import { Rocket, ShieldCheck, Clock4, Users, Code2, HeartHandshake } from "lucide-react";

const FEATURES = [
	{
		icon: Code2,
		title: "Clean, Scalable Code",
		desc: "Maintainable, well-documented code built to scale — no shortcuts, no tech debt.",
		number: "01",
	},
	{
		icon: Rocket,
		title: "Fast Time-to-Market",
		desc: "Agile sprints and streamlined workflows ship your product faster without sacrificing quality.",
		number: "02",
	},
	{
		icon: ShieldCheck,
		title: "Reliable & Secure",
		desc: "Enterprise-grade security, rigorous QA, and zero-bug policy before every release.",
		number: "03",
	},
	{
		icon: Users,
		title: "Dedicated Team",
		desc: "Designer, developer, QA, and PM — hand-picked and fully committed to your product.",
		number: "04",
	},
	{
		icon: Clock4,
		title: "On-Time Delivery",
		desc: "Transparent timelines, honest updates, and absolutely no surprise delays.",
		number: "05",
	},
	{
		icon: HeartHandshake,
		title: "Long-Term Partnership",
		desc: "We stay on after launch to iterate, grow, and support your product.",
		number: "06",
	},
];

const STATS = [
	{ value: "2+", label: "Apps Delivered" },
	{ value: "98%", label: "Client Retention" },
	{ value: "2 Yrs", label: "In Business" },
];

export default function WhyChooseUs() {
	return (
		<section className="pt-16 pb-24 text-white overflow-hidden bg-[#1a1a1a]">
			<style>{`
				@keyframes wcuPulse {
					0%, 100% { opacity: 1; transform: scale(1); }
					50% { opacity: 0.5; transform: scale(0.85); }
				}
				.wcu-pulse { animation: wcuPulse 2s infinite; }
				.wcu-stat-card:hover { transform: translateY(-3px); }
			`}</style>

			<div className="container">

				{/* ── Header ── */}
				<div className="text-center mb-14">
					<h2 className="text-4xl md:text-5xl font-bold leading-tight tracking-tight mb-4">
						Why Choose Us
					</h2>
				</div>

				{/* ── Stats Row ── */}
				<div className="grid grid-cols-3 gap-2 sm:gap-3 mb-11">
					{STATS.map((s, i) => (
						<div
							key={i}
							className="wcu-stat-card text-center py-4 sm:py-6 px-2 sm:px-4 rounded-2xl bg-white/[0.02] border border-white/[0.07] transition-all duration-300 hover:bg-purple-500/[0.08] hover:border-purple-500/30 hover:shadow-xl"
						>
							<p className="text-2xl sm:text-4xl font-extrabold leading-none bg-gradient-to-br from-purple-400 to-blue-400 bg-clip-text text-transparent">
								{s.value}
							</p>
							<p className="text-xs sm:text-sm text-white/60 mt-2 sm:mt-2.5 tracking-wide">
								{s.label}
							</p>
						</div>
					))}
				</div>

				{/* Divider */}
				<div className="h-px bg-gradient-to-r from-transparent via-white/[0.07] to-transparent mb-2" />

				{/* ── Features 3-col Grid ── */}
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1 mt-2">
					{FEATURES.map((f, i) => {
						const Icon = f.icon;
						return (
							<div
								key={i}
								className="wcu-row group flex gap-4 p-5 rounded-2xl border border-transparent transition-all duration-300 hover:bg-purple-500/[0.05] hover:border-purple-500/20 cursor-default"
							>
								{/* Icon */}
								<div className="wcu-row-icon w-11 h-11 rounded-xl flex items-center justify-center bg-gradient-to-r from-purple-600 to-blue-600 shrink-0 transition-all duration-300">
									<Icon size={20} className="text-white" />
								</div>

								{/* Text */}
								<div>
									<p className="font-semibold text-white/95 mb-2 text-lg">
										{f.title}
									</p>
									<p className="text-base text-white/60 leading-relaxed">
										{f.desc}
									</p>
								</div>
							</div>
						);
					})}
				</div>

			</div>
		</section>
	);
}